import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { ContactForm } from './components/ContactForm';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';
import { BrandBook } from './pages/BrandBook';
import { PlanoTool } from './pages/PlanoTool';
import { PinFotos } from './pages/PinFotos';
export function App() {
  const [showBrandBook, setShowBrandBook] = useState(false);
  const [showPlanoTool, setShowPlanoTool] = useState(false);
  const [showPinFotos, setShowPinFotos] = useState(false);
  useEffect(() => {
    const checkHash = () => {
      setShowBrandBook(window.location.hash === '#brand');
      setShowPlanoTool(window.location.hash === '#plano');
      setShowPinFotos(window.location.hash === '#pinfotos');
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);
  // If ?telefono param exists, go straight to PinFotos
  const url = new URL(window.location.href);
  const telefono = url.searchParams.get('telefono');
  if (telefono) {
    return <PinFotos data-id="element-0" />;
  }
  if (showPinFotos) {
    return <PinFotos data-id="element-1" />;
  }
  if (showPlanoTool) {
    return <PlanoTool data-id="element-2" />;
  }
  if (showBrandBook) {
    return <BrandBook data-id="element-3" />;
  }
  return <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900" data-id="element-4">
      <Navbar data-id="element-5" />

      <main data-id="element-6">
        <HeroSection data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <HowItWorksSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <ContactForm data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}